import React, { ChangeEvent, useEffect, useState } from 'react'
import { PhotoIcon } from '@heroicons/react/20/solid'
import { UploaderProps } from '../../types'

export const Uploader: React.FC<UploaderProps> = ({
    accept,
    titleText,
    file,
    setFile,
    preview,
    maxSizeBytes
}) => {
    const [errorMsg, setErrorMsg] = useState<string>()
    const clearFile = () => file && setFile(undefined)

    const onChangeFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
        setFile(event.target.files?.[0])
    }

    useEffect(() => {
        if (file) {
            if (!accept.includes(file.type)) {
                setErrorMsg('Некорректный тип файла')
                console.error('Некорректный тип файла. Ожидаемый тип: ', accept)
                clearFile()
                return
            }
            if (maxSizeBytes && file.size > maxSizeBytes) {
                setErrorMsg('Слишком большой файл')
                clearFile()
                return
            }

            setErrorMsg(undefined)
        }
    }, [file])

    const uploadPreview = file
        ? file.type.includes('image/')
            ? <img
                src={URL.createObjectURL(file)} alt={file.name}
                className="max-h-[300px] w-full"
            />
            : <p/> /*todo: add non-image file type*/
        : preview

    const uploader = (
        <div className="flex justify-center border border-dashed border-gray-900/25 md:px-6 md:py-10">

            <div className="text-center">

                <div className="flex text-sm leading-6 text-gray-600">
                    <label
                        onClick={clearFile}
                        htmlFor="file-upload"
                        className="relative cursor-pointer rounded-md bg-white font-semibold text-blue-500 hover:text-blue-400"
                    >
                        {
                            file ?
                                uploadPreview
                                : <>
                                    <PhotoIcon className="mx-auto h-12 w-12 text-gray-300"
                                               aria-hidden="true"/>
                                    {titleText}
                                    <input
                                        id="file-upload"
                                        name="file-upload"
                                        type="file"
                                        accept={accept.join(', ')}
                                        className="sr-only"
                                        onInput={onChangeFileUpload}
                                    />
                                </>
                        }
                    </label>
                </div>

            </div>
        </div>
    )
    const error = errorMsg &&
        (<p className="mt-3 text-sm leading-6 text-red-600">
            {errorMsg}
        </p>)

    return (
        <div>
            {uploader}
            {error}
        </div>
    )

}
